import { Injectable } from '@angular/core'
import { Store } from '@ngrx/store'
import { VideoPlayHistoryApi } from '../../apis'
import { AppState } from '../../reducers'
import { PlayHistoryService } from './base'

@Injectable()
export class VideoPlayHistoryService extends PlayHistoryService{
  constructor(protected api: VideoPlayHistoryApi) {
    super(api)
  }
}



// WEBPACK FOOTER //
// ./src/services/play-history/video.ts